import {Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import {ExportToExcel} from "../ExportToExcel.jsx";
import {CopyDataToClipboard} from "../CopyDataToClipboard.jsx";
import TooltipInfo from "../TooltipInfo.jsx";
import {useSelector} from "react-redux";

export const BarChartAnaliza = ({
                                    data,
                                    xDatakey,
                                    dataKeys,
                                    title,
                                    selectors,
                                    customLegend,
                                    tooltipFormatter,
                                    hideExelExport = false,
                                    hideCopyToclipboard = false,
                                    tooltipKey,
                                }) => {
    const tooltipHtml = useSelector(state =>
        state.chartTooltips?.msg?.[tooltipKey]?.value
    );

    return (
        <Card>
            <Card.Header>
                <div className={'d-flex justify-content-between gap-3'}>
                    <div className={'d-flex justify-content-between'}>
                        <div className={'fs-5'}>
                            {title ?? 'Analiza'}
                        </div>
                        <div>
                            {tooltipHtml && (
                                <TooltipInfo text={tooltipHtml} className="ms-2" />
                            )}
                        </div>
                    </div>
                    <div className={'w-25'}>
                        {!!selectors && selectors}
                    </div>
                    <div>
                        {(!hideExelExport && data) &&
                            <ExportToExcel
                                data={data}
                                fileName={title || 'analiza'}
                            />
                        }
                        {(!hideCopyToclipboard && data) &&
                            <CopyDataToClipboard data={data}/>
                        }
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <ResponsiveContainer width="100%" height={300}>
                    <BarChart data={data}>
                        <Tooltip
                            formatter={tooltipFormatter || null}
                        />
                        <YAxis/>
                        <XAxis dataKey={xDatakey}/>
                        <Legend payload={customLegend || null}/>
                        <CartesianGrid strokeDasharray="3 3"/>
                        {
                            dataKeys.map((dataKey, idx) => (
                                <Bar key={idx} dataKey={dataKey.dataKey} fill={dataKey.color}/>
                            ))
                        }

                    </BarChart>
                </ResponsiveContainer>
            </Card.Body>
        </Card>
    )
}

BarChartAnaliza.propTypes = {
    data: PropTypes.array.isRequired,
    dataKeys: PropTypes.array.isRequired,
    xDatakey: PropTypes.string.isRequired,
    yDatakey: PropTypes.string.isRequired,
    fill: PropTypes.string,
    title: PropTypes.string,
    colors: PropTypes.array,
    selectors: PropTypes.element,
    customLegend: PropTypes.array,
    tooltipFormatter: PropTypes.func,
    hideExelExport: PropTypes.bool,
    hideCopyToclipboard: PropTypes.bool,
    tooltipKey: PropTypes.string,
}
